var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{class:(_vm.message.msg.success == true) ? 'success' : 'error'},[_vm._v("\n    "+_vm._s(_vm.message.msg.message)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }